import React from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from '@iconify/react';

/**
 * Matches the Full screen / Exit Full screen controls next to BiQ on Analytics.
 * `heightClass` lets callers match a different control row height; the default
 * 40px is what the Global Produce Map strip uses.
 * `compact` renders an icon-only variant (label dropped, square padding) for
 * the title-adjacent control on small screens — see ChartFullscreenTitleControl.
 */
const AnalyticsChartFullscreenButton = ({ isActive, onEnter, onExit, heightClass = 'h-10', compact = false }) => {
  const { t } = useTranslation();
  if (!onEnter || !onExit) return null;

  const compactBtn = compact
    ? 'max-sm:w-10 max-sm:px-0 max-sm:gap-0 justify-center sm:px-4'
    : 'px-4';
  const labelClass = compact ? 'hidden sm:inline' : undefined;

  if (isActive) {
    return (
      <button
        type="button"
        onClick={onExit}
        aria-label={t('analytics.exitFullScreen', 'Exit Full Screen')}
        className={`${heightClass} ${compactBtn} rounded-lg border border-[#E8EBE9] dark:border-[#3a3c3b] bg-[#FBE4C6] text-[#282A29] text-sm font-medium transition-colors flex items-center gap-2 cursor-pointer shrink-0 whitespace-nowrap`}
      >
        <Icon icon="ant-design:fullscreen-outlined" width={compact ? '18' : '16'} height={compact ? '18' : '16'} className="text-bloom-green shrink-0" />
        <span className={labelClass}>{t('analytics.exitFullScreen', 'Exit Full Screen')}</span>
      </button>
    );
  }

  return (
    <button
      type="button"
      onClick={onEnter}
      aria-label={t('analytics.fullScreen', 'Full screen')}
      className={`${heightClass} ${compactBtn} rounded-lg border border-[#E8EBE9] dark:border-[#3a3c3b] bg-white dark:bg-[#191919] text-[#282A29] dark:text-white text-sm font-medium hover:border-bloom-green/60 transition-colors flex items-center gap-2 cursor-pointer shrink-0 whitespace-nowrap`}
    >
      <Icon icon="ant-design:fullscreen-outlined" width={compact ? '18' : '16'} height={compact ? '18' : '16'} className="text-bloom-green shrink-0" />
      <span className={labelClass}>{t('analytics.fullScreen', 'Full screen')}</span>
    </button>
  );
};

export default AnalyticsChartFullscreenButton;
